import { Grid } from "@mui/material";
import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import PageLayout from "../../Components/LayoutContainers/PageLayout";
import GhabzIndex from "./components/Ghabz/Ghabz";

export default function PrintHtml() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [page, setPage] = useState<string | null>(searchParams.get("comp"));
  if (page === null) navigate("/notfound", { replace: true });
  return (
    <PageLayout>
      <>
        {(() => {
          switch (page) {
            case "ghabz":
              return <GhabzIndex ghabzId={() => searchParams.get("Id")} />;
              break;
            default:
              navigate("/notfound", { replace: true });
              break;
          }
        })()}
      </>
    </PageLayout>
  );
}
